<div [ngSwitch]="admin">
  <nav mat-tab-nav-bar *ngSwitchCase="true">
    <a
      mat-tab-link
      [active]="home.isActive"
      #home="routerLinkActive"
      routerLink="/admin"
      [routerLinkActive]="['router-link-active']"
      [routerLinkActiveOptions]="{ exact: true }"
      >Home</a
    >

    <a
      *ngIf="admin"
      mat-tab-link
      [active]="organisations.isActive"
      #organisations="routerLinkActive"
      [routerLink]="['/admin/organisations']"
      [routerLinkActive]="['router-link-active']"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      Organisations
    </a>
    <a
      *ngIf="admin"
      mat-tab-link
      [active]="categories.isActive"
      #categories="routerLinkActive"
      [routerLink]="['/admin/categories']"
      [routerLinkActive]="['router-link-active']"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      Categories
    </a>
  </nav>
  <nav mat-tab-nav-bar *ngSwitchDefault>
    <a
      mat-tab-link
      [active]="home.isActive"
      #home="routerLinkActive"
      routerLink="./"
      [routerLinkActive]="['router-link-active']"
      [routerLinkActiveOptions]="{ exact: true }"
      >Home</a
    >
    <a
      mat-tab-link
      *ngIf="organisationId"
      [active]="invite.isActive"
      #invite="routerLinkActive"
      [routerLink]="['/organisations', organisationId, 'team']"
      [routerLinkActive]="['router-link-active']"
      [routerLinkActiveOptions]="{ exact: false }"
      >Members</a
    >
    <a
      mat-tab-link
      *ngIf="organisationId"
      [active]="customers.isActive"
      #customers="routerLinkActive"
      [routerLink]="['/organisations', organisationId, 'communities']"
      [routerLinkActive]="['router-link-active']"
      [routerLinkActiveOptions]="{ exact: false }"
      >Communities</a
    >
    <a
      mat-tab-link
      *ngIf="organisationId"
      [active]="preferences.isActive"
      #preferences="routerLinkActive"
      [routerLink]="['/organisations', organisationId, 'preferences']"
      [routerLinkActive]="['router-link-active']"
      [routerLinkActiveOptions]="{ exact: false }"
      >Preferences</a
    >
  </nav>
</div>
